import {environment} from '../../environments/environment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { throwError  } from 'rxjs';
declare var soap: any;

@Injectable()
export class TeacherClassroomService {

  headers: any;
  options: any;

  constructor(private http: HttpClient) {
    const headersItem = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    this.headers = headersItem;
    this.options = {headers: this.headers};
  }


  getClassRoomListData() {
    return this.http.get(environment.restAPI + 'classrooms', this.options)
      .pipe(
        map((res: any) => res), // ...and calling .json() on the response to return data
        tap(data => data),
        catchError(this.handleError)); // ...errors if any

  }

  handleError(error: Response) {
    return throwError(error);
  }


}
